export default __webpack_public_path__ + "static/media/757.70d1b81f.png";